<template>
    <div class="course-container">
        <!--详情-->
        <div class="topic-detail" v-if="showMode==='view'">
            <div class="sub-topic-top">
                <div class="topic-top-left">
                    <div class="top-left1">
                        <div style="margin-right: 10px;">教研赛事</div>
                        <div v-if="info.status===0" class="status-info-cs">初始阶段</div>
                        <div v-if="info.status===1" class="status-info-bm">报名阶段</div>
                        <div v-if="info.status===2" class="status-info-cs">初审阶段</div>
                        <div v-if="info.status===3" class="status-info-fs">复审阶段</div>
                        <div v-if="info.status===4" class="status-info-zs">终审阶段</div>
                        <div v-if="info.status===5" class="status-info-zs">现场评比</div>
                        <div v-if="info.status===6" class="status-info-js">竞赛结束</div>
                    </div>
                    <div class="top-left2">
                        <span v-if="info.status===0||info.status===1">报名阶段&nbsp;&nbsp; {{ timestampToTime(info.beginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.endTime)}}</span>
                        <span v-if="info.status===2">初审阶段&nbsp;&nbsp; {{ timestampToTime(info.csBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.csEndTime)}}</span>
                        <span v-if="info.status===3">复审阶段&nbsp;&nbsp; {{ timestampToTime(info.fsBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.fsEndTime)}}</span>
                        <span v-if="info.status===4">终审阶段&nbsp;&nbsp; {{ timestampToTime(info.zsBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.zsEndTime)}}</span>
                        <span v-if="info.status===5">现场评比&nbsp;&nbsp; {{ timestampToTime(info.evaBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.evaEndTime)}}</span>
                        <span v-if="info.status===6">竞赛结束</span>
                    </div>
                </div>
                <div class="topic-top-right">
                    <!--报名阶段-->
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===0">
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===0">
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===0">
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isSign===1&&info.isApply===0">
                        <div class="bm-btn" @click="raceSignUp">立即报名</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.csStatus!==3">
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.csStatus!==3">
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.csStatus!==3">
                        <div class="bm-btn" @click="raceSignUp">报名编辑</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.csStatus===3">
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.csStatus===3">
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.csStatus===3">
                        <div class="bm-btn" @click="viewSignUp">查看资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&(this.signForm.csStatus===1||this.signForm.csStatus===2)">
                        <div class="bm-btn bg-dsh">待审核</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.csStatus===3">
                        <div class="bm-btn bg-ytg">已通过</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===1&&info.isApply===1&&this.signForm.csStatus===4">
                        <div class="bm-btn bg-wtg">未通过</div>
                    </div>
                    <!--初审阶段-->
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&(this.signForm.csStatus===1||this.signForm.csStatus===2)">
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&(this.signForm.csStatus===1||this.signForm.csStatus===2)">
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&(this.signForm.csStatus===1||this.signForm.csStatus===2)">
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&(this.signForm.csStatus===1||this.signForm.csStatus===2)">
                        <div class="bm-btn bg-ytg">审核中</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.csStatus===3">
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.csStatus===3">
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.csStatus===3">
                        <div class="bm-btn" @click="viewSignUp">查看资料</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.csStatus===3">
                        <div class="bm-btn bg-ytg">已通过</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.csStatus===4">
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.csStatus===4">
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.csStatus===4">
                        <div class="bm-btn" @click="raceSignUp">报名编辑</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===2&&info.isApply===1&&this.signForm.csStatus===4">
                        <div class="bm-btn bg-wtg">未通过</div>
                    </div>
                    <!--复审阶段-->
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&(this.signForm.fsStatus===1||this.signForm.fsStatus===2)">
                    </div>
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&(this.signForm.fsStatus===1||this.signForm.fsStatus===2)">
                    </div>
                    <div class="right-ntn-auto" v-if="info.status===3&&info.isApply===1&&(this.signForm.fsStatus===1||this.signForm.fsStatus===2)">
                        <div class="bm-btn-auto bg-ytg">分配:{{this.signForm.fsDivideCount}},审核:{{this.signForm.fsCheckCount}}</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&(this.signForm.fsStatus===1||this.signForm.fsStatus===2)">
                        <div class="bm-btn bg-ytg">审核中</div>
                    </div>

                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&this.signForm.fsStatus===3">
                    </div>
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&this.signForm.fsStatus===3">
                    </div>
                    <div class="right-ntn-auto" v-if="info.status===3&&info.isApply===1&&this.signForm.fsStatus===3">
                        <div class="bm-btn bg-ytg">{{this.signForm.fsScore}}</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===3&&info.isApply===1&&this.signForm.fsStatus===3">
                        <div class="bm-btn bg-ytg">审核完成</div>
                    </div>
                    <!--终审阶段-->
                    <div class="right-ntn" v-if="info.status===4&&info.isApply===1&&(this.signForm.zsStatus===1||this.signForm.zsStatus===2)">
                    </div>
                    <div class="right-ntn" v-if="info.status===4&&info.isApply===1&&(this.signForm.zsStatus===1||this.signForm.zsStatus===2)">
                    </div>
                    <div class="right-ntn-auto" v-if="info.status===4&&info.isApply===1&&(this.signForm.zsStatus===1||this.signForm.zsStatus===2)">
                        <div class="bm-btn-auto bg-ytg">分配:{{this.signForm.zsDivideCount}},审核:{{this.signForm.zsCheckCount}}</div>
                    </div>
                    <div class="right-ntn" v-if="info.status===4&&info.isApply===1&&(this.signForm.zsStatus===1||this.signForm.zsStatus===2)">
                        <div class="bm-btn bg-ytg">审核中</div>
                    </div>
                    <!--无现场评比-->
                    <div class="right-ntn" v-if="info.isEva===0&&info.status===4&&info.isApply===1&&this.signForm.zsStatus===3">
                    </div>
                    <div class="right-ntn" v-if="info.isEva===0&&info.status===4&&info.isApply===1&&this.signForm.zsStatus===3">
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===0&&info.status===4&&info.isApply===1&&this.signForm.zsStatus===3">
                        <div class="zs-info">综合分</div>
                        <div class="bm-btn bg-ytg">{{this.signForm.zsScore}}</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===0&&info.status===4&&info.isApply===1&&this.signForm.zsStatus===3&&this.signForm.awardStatus===0">
                        <div class="zs-info">定级</div>
                        <div class="bm-btn bg-dj">未定级</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===0&&info.status===4&&info.isApply===1&&this.signForm.zsStatus===3&&this.signForm.awardStatus===1">
                        <div class="zs-info">定级</div>
                        <div class="bm-btn bg-dj" @click="viewAware(this.signForm)">{{this.signForm.award.awardName}}</div>
                    </div>
                    <!--有现场评比-->
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===4&&info.isApply===1&&this.signForm.zsStatus===3">
                        <div class="zs-info">线上分{{100-info.evaWeight}}%</div>
                        <div class="bm-btn bg-ytg">{{this.signForm.zsScore}}</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===4&&info.isApply===1&&this.signForm.zsStatus===3">
                        <div class="zs-info">现场分{{info.evaWeight}}%</div>
                        <div class="bm-btn bg-xc">{{this.signForm.xcScore}}</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===4&&info.isApply===1&&this.signForm.zsStatus===3">
                        <div class="zs-info">综合分</div>
                        <div class="bm-btn bg-dj">{{this.signForm.zhScore}}</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===4&&info.isApply===1&&this.signForm.zsStatus===3&&this.signForm.awardStatus===0">
                        <div class="zs-info">定级</div>
                        <div class="bm-btn bg-dj">未定级</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===4&&info.isApply===1&&this.signForm.zsStatus===3&&this.signForm.awardStatus===1">
                        <div class="zs-info">定级</div>
                        <div class="bm-btn bg-dj" @click="viewAware(this.signForm)">{{this.signForm.award.awardName}}</div>
                    </div>
                    <!--现场评比-->
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===5&&info.isApply===1&&this.signForm.zsStatus===3">
                        <div class="zs-info">线上分{{100-info.evaWeight}}%</div>
                        <div class="bm-btn bg-ytg">{{this.signForm.zsScore}}</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===5&&info.isApply===1&&this.signForm.zsStatus===3">
                        <div class="zs-info">现场分{{info.evaWeight}}%</div>
                        <div class="bm-btn bg-xc">{{this.signForm.xcScore}}</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===5&&info.isApply===1&&this.signForm.zsStatus===3">
                        <div class="zs-info">综合分</div>
                        <div class="bm-btn bg-dj">{{this.signForm.zhScore}}</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===5&&info.isApply===1&&this.signForm.zsStatus===3&&this.signForm.awardStatus===0">
                        <div class="zs-info">定级</div>
                        <div class="bm-btn bg-dj">未定级</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===5&&info.isApply===1&&this.signForm.zsStatus===3&&this.signForm.awardStatus===1">
                        <div class="zs-info">定级</div>
                        <div class="bm-btn bg-dj" @click="viewAware(this.signForm)">{{this.signForm.award.awardName}}</div>
                    </div>


                    <!--竞赛结束-->
                    <div class="right-ntn" v-if="info.isEva===0&&info.status===6&&info.isApply===1&&this.signForm.zsStatus===3">
                    </div>
                    <div class="right-ntn" v-if="info.isEva===0&&info.status===6&&info.isApply===1&&this.signForm.zsStatus===3">
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===0&&info.status===6&&info.isApply===1&&this.signForm.zsStatus===3">
                        <div class="zs-info">综合分</div>
                        <div class="bm-btn bg-ytg">{{this.signForm.zsScore}}</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===0&&info.status===6&&info.isApply===1&&this.signForm.zsStatus===3&&this.signForm.awardStatus===0">
                        <div class="zs-info">定级</div>
                        <div class="bm-btn bg-dj">未定级</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===0&&info.status===6&&info.isApply===1&&this.signForm.zsStatus===3&&this.signForm.awardStatus===1">
                        <div class="zs-info">定级</div>
                        <div class="bm-btn bg-dj" @click="viewAware(this.signForm)">{{this.signForm.award.awardName}}</div>
                    </div>
                    <!--有现场评比-->
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===6&&info.isApply===1&&this.signForm.zsStatus===3">
                        <div class="zs-info">线上分{{100-info.evaWeight}}%</div>
                        <div class="bm-btn bg-ytg">{{this.signForm.zsScore}}</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===6&&info.isApply===1&&this.signForm.zsStatus===3">
                        <div class="zs-info">现场分{{info.evaWeight}}%</div>
                        <div class="bm-btn bg-xc">{{this.signForm.xcScore}}</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===6&&info.isApply===1&&this.signForm.zsStatus===3">
                        <div class="zs-info">综合分</div>
                        <div class="bm-btn bg-dj">{{this.signForm.zhScore}}</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===6&&info.isApply===1&&this.signForm.zsStatus===3&&this.signForm.awardStatus===0">
                        <div class="zs-info">定级</div>
                        <div class="bm-btn bg-dj">未定级</div>
                    </div>
                    <div class="right-zs-auto" v-if="info.isEva===1&&info.status===6&&info.isApply===1&&this.signForm.zsStatus===3&&this.signForm.awardStatus===1">
                        <div class="zs-info">定级</div>
                        <div class="bm-btn bg-dj" @click="viewAware(this.signForm)">{{this.signForm.award.awardName}}</div>
                    </div>


                </div>
            </div>

            <div class="topic-container">
                <div class="topic-name-container">
                    {{info.raceName}}
                </div>

                <div class="topic-time-container">
                    <div class="topic-time-top">
                        <div class="topic-time-top1">
                            <svg t="1745994882084" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9405" width="18" height="18"><path d="M597.333333 618.666667h149.333334c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666667H597.333333c-25.6 0-42.666667 17.066667-42.666666 42.666667s17.066667 42.666667 42.666666 42.666667zM597.333333 832h149.333334c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666666H597.333333c-25.6 0-42.666667 17.066667-42.666666 42.666666s17.066667 42.666667 42.666666 42.666667zM277.333333 618.666667H426.666667c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666667H277.333333c-25.6 0-42.666667 17.066667-42.666666 42.666667s17.066667 42.666667 42.666666 42.666667zM277.333333 832H426.666667c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666666H277.333333c-25.6 0-42.666667 17.066667-42.666666 42.666666s17.066667 42.666667 42.666666 42.666667z" p-id="9406" fill="#ff7f2e"></path><path d="M874.666667 85.333333h-128V42.666667c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667v42.666666h-298.666666V42.666667c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667v42.666666h-128C89.6 85.333333 42.666667 132.266667 42.666667 192v725.333333C42.666667 977.066667 89.6 1024 149.333333 1024h725.333334c59.733333 0 106.666667-46.933333 106.666666-106.666667v-725.333333C981.333333 132.266667 934.4 85.333333 874.666667 85.333333zM128 192c0-12.8 8.533333-21.333333 21.333333-21.333333h128v42.666666c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V170.666667h298.666666v42.666666c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V170.666667h128c12.8 0 21.333333 8.533333 21.333333 21.333333V341.333333H128V192z m768 725.333333c0 12.8-8.533333 21.333333-21.333333 21.333334h-725.333334c-12.8 0-21.333333-8.533333-21.333333-21.333334V426.666667h768v490.666666z" p-id="9407" fill="#ff7f2e"></path></svg>
                        </div>
                        <div class="topic-time-top2">
                            竞赛时间安排
                        </div>
                    </div>

                    <div class="topic-jd">
                        <div class="topic-jd1">
                            <div class="topic-point"></div>
                        </div>
                        <div :class="info.status===1?'topic-jd2 time-active':'topic-jd2'">报名阶段</div>
                    </div>
                    <div :class="info.status===1?'topic-jd-time time-active':'topic-jd-time'">
                        {{ timestampToTime(info.beginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.endTime)}}
                    </div>

                    <div class="topic-jd" v-if="info.checkMode==='2'||info.checkMode==='3'">
                        <div class="topic-jd1">
                            <div class="topic-point"></div>
                        </div>
                        <div :class="info.status===2?'topic-jd2 time-active':'topic-jd2'">初审阶段</div>
                    </div>
                    <div :class="info.status===2?'topic-jd-time time-active':'topic-jd-time'" v-if="info.checkMode==='2'||info.checkMode==='3'">
                        {{ timestampToTime(info.csBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.csEndTime)}}
                    </div>

                    <div class="topic-jd" v-if="info.checkMode==='3'">
                        <div class="topic-jd1">
                            <div class="topic-point"></div>
                        </div>
                        <div :class="info.status===3?'topic-jd2 time-active':'topic-jd2'">复审阶段</div>
                    </div>
                    <div :class="info.status===3?'topic-jd-time time-active':'topic-jd-time'" v-if="info.checkMode==='3'">
                        {{ timestampToTime(info.fsBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.fsEndTime)}}
                    </div>

                    <div class="topic-jd">
                        <div class="topic-jd1">
                            <div class="topic-point"></div>
                        </div>
                        <div :class="info.status===4?'topic-jd2 time-active':'topic-jd2'">终审阶段</div>
                    </div>
                    <div :class="info.status===4?'topic-jd-time-end time-active':'topic-jd-time-end'">
                        {{ timestampToTime(info.zsBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.zsEndTime)}}
                    </div>
                </div>

                <div class="topic-title-container">
                    <div class="topic-title-container1">
                        <svg t="1745994994411" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10489" width="24" height="24"><path d="M210.823529 839.183059V120.470588H146.040471C114.672941 120.470588 90.352941 152.997647 90.352941 180.976941v787.681883C90.352941 987.030588 100.020706 1024 146.040471 1024h621.492705C782.351059 1024 813.176471 1008.941176 813.176471 968.643765V918.588235H290.590118C245.955765 918.588235 210.823529 872.779294 210.823529 839.183059zM786.808471 180.705882h160.015058L768 0v162.590118c0 12.182588 6.144 18.115765 18.808471 18.115764z" p-id="10490" fill="#ff7f2e"></path><path d="M786.808471 195.764706C765.906824 195.764706 752.941176 183.055059 752.941176 162.590118V0H275.531294C246.287059 0 225.882353 21.443765 225.882353 51.772235L226.123294 120.470588H225.882353v718.712471C225.882353 865.249882 258.514824 903.529412 290.590118 903.529412H881.935059C912.384 903.529412 948.705882 868.201412 948.705882 839.183059V195.764706H786.808471zM813.176471 692.705882H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058824s-6.776471 15.058824-15.058823 15.058823z m0-225.882353H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058824s-6.776471 15.058824-15.058823 15.058823z m0-210.823529H378.157176c-5.270588 8.704-14.757647 14.592-25.690352 14.592a30.117647 30.117647 0 0 1 0-60.235294c11.309176 0 21.052235 6.309647 26.202352 15.525647H813.176471c8.282353 0 15.058824 6.776471 15.058823 15.058823s-6.776471 15.058824-15.058823 15.058824z" p-id="10491" fill="#ff7f2e"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        基础信息
                    </div>
                </div>
                <div class="topic-base-info-container">
                    <div class="base-one-container">
                        <div class="base-one-info-80">竞赛名称：<span style="color: #767676">{{info.raceName}}</span></div>
                    </div>
                </div>
                <div class="topic-base-info-container">
                    <div class="base-one-container">
                        <div class="base-one-info">竞赛级别：<span style="color: #767676">{{info.raceLevelName}}</span></div>
                        <div class="base-one-info">竞赛方向：<span style="color: #767676">{{info.raceDirectionName}}</span></div>
                    </div>
                </div>
                <div class="topic-base-info-container">
                    <div class="base-one-container">
                        <div class="base-one-info">主办单位：<span style="color: #767676">{{info.hostOrgName}}</span></div>
                        <div class="base-one-info">竞赛负责人：<span style="color: #767676">{{info.raceLeaderName}}</span></div>
                    </div>
                </div>

                <div class="topic-base-info-container">
                    <div class="base-one-container">
                        <div class="base-one-info">竞赛范围：<span style="color: #767676">{{info.raceNatureName}}</span></div>
                        <div class="base-one-info">联系方式：<span style="color: #767676">{{info.contactInfo}}</span></div>
                    </div>
                </div>
                <!--竞赛介绍文字-->
                <div class="topic-title-container" v-if="info.raceType===0&&info.raceOverview">
                    <div class="topic-title-container1">
                        <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#ff7f2e" p-id="12410"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        竞赛介绍
                    </div>
                </div>
                <div class="topic-content-container" v-if="info.raceType===0&&info.raceOverview">
                    {{info.raceOverview}}
                </div>
                <div class="topic-title-container" v-if="info.raceType===0&&info.raceRule">
                    <div class="topic-title-container1">
                    </div>
                    <div class="topic-title-container2">
                        报名要求
                    </div>
                </div>
                <div class="topic-content-container" v-if="info.raceType===0&&info.raceRule">
                    {{info.raceRule}}
                </div>

                <!--竞赛图片-->
                <div class="topic-title-container" v-if="info.raceType===1&&info.imgUrl">
                    <div class="topic-title-container1">
                        <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#ff7f2e" p-id="12410"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        竞赛介绍
                    </div>
                </div>
                <div class="topic-content-container-img" v-if="info.raceType===1&&info.imgUrl">
                    <el-image style="width: 200px; height: 320px;cursor: pointer"
                              :src="info.imgUrl"
                              :preview-teleported="true"
                              :preview-src-list="[info.imgUrl]"
                              :initial-index="1"
                              fit="fill" />
                </div>

                <div class="topic-title-container" v-if="info.fileList&&info.fileList.length>0">
                    <div class="topic-title-container1">
                        <svg t="1746001513851" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15262" width="24" height="24"><path d="M512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z m128 502.613A128 128 0 0 1 502.613 640l-216.746 98.133L384 521.387A128 128 0 0 1 521.387 384l216.746-98.133z" fill="#ff7f2e" p-id="15263"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        竞赛附件
                    </div>
                </div>
                <div class="file-list">
                    <div class="file-item" v-for="item in info.fileList" :key="item">
                        <div class="file-title" style="text-indent: 30px" @click="downloadFile(item)">{{item.fileName}}</div>
                        <div class="file-view">
                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                      :src="require('@/assets/file/file_view_color.png')"
                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                            </el-image>
                        </div>
                        <div class="file-view" @click="downloadFile(item)">
                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                        </div>
                    </div>
                </div>
                <!--现场评比-->
                <div class="topic-title-container" v-if="info.isEva===1">
                    <div class="topic-title-container1">
                        <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="24" height="24"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#ff7f2e" p-id="12410"></path></svg>
                    </div>
                    <div class="topic-title-container2">
                        现场评比
                    </div>
                </div>
                <div class="topic-base-info-container" v-if="info.isEva===1">
                    <div class="base-one-container">
                        <div class="base-one-info-80">评比权重：<span style="color: #767676">{{ info.evaWeight}}%</span></div>
                    </div>
                    <div class="base-one-container">
                        <div class="base-one-info-80">评比时间：<span style="color: #767676">{{ timestampToTime(info.evaBeginTime)}}&nbsp;-&nbsp;{{ timestampToTime(info.evaEndTime)}}</span></div>
                    </div>
                    <div class="base-one-container">
                        <div class="base-one-info-80">评比地址：<span style="color: #767676">{{ info.evaAddress}}</span></div>
                    </div>
                    <div class="part-container">
                        <div class="map-container">
                            <aMap isDetail v-if="isShowMap" ref="zdyMap"
                                  @getGeocoder="getGeocoder"
                                  :oldCenter="oldCenter"
                                  :isShowAMap="true">
                            </aMap>
                        </div>

                    </div>
                </div>
            </div>

            <div class="back-btn-container">
                <div class="apply-btn-back" @click="changeModel">返回</div>
            </div>
        </div>
        <!--提交报名资料-->
        <div class="topic-detail" v-show="showMode==='sign'">
            <div class="topic-sign-container">
                <div class="topic-sign-title">竞赛报名</div>
                <div class="topic-sign-name">
                    {{info.raceName}}
                </div>
                <div class="topic-sign-form">
                    <el-form ref="signForm" :model="signForm"
                             :rules="signRules"
                             label-position="top">
                        <div class="topic-sign-title">基本信息</div>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="教师姓名" prop="trueName">
                                    <el-input disabled v-model="signForm.trueName" placeholder="请输入教师姓名"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="所属学校" prop="trueName">
                                    <el-input disabled v-model="signForm.orgName" placeholder="请输入所属学校"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="任教学段" prop="periodKey">
                                    <el-select @change="changePeriod" style="width: 100%;" v-model="signForm.periodKey"
                                               placeholder="请选择任教学段">
                                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="任教学科" prop="subjectKey">
                                    <el-select style="width: 100%;" v-model="signForm.subjectKey"
                                               placeholder="请选择任教学科">
                                        <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="最高学历" prop="qualificationKey">
                                    <el-select style="width: 100%;" v-model="signForm.qualificationKey"
                                               placeholder="请选择最高学历">
                                        <el-option v-for="item in qualificationList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="技术职称" prop="rankLevel">
                                    <el-select style="width: 100%;" v-model="signForm.rankLevel"
                                               placeholder="请选择技术职称">
                                        <el-option v-for="item in rankList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="topic-sign-title">附件说明</div>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="课例名称" prop="lessonName" label-position="left">
                                    <el-input v-model="signForm.lessonName" placeholder="请输入课例名称" />
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>课堂实录
                            </div>
                            <div>
                                <el-upload class="upload-demo"
                                           v-model:file-list="ktslFileList"
                                           :action="serviceUrl+'/businessservice/raceSign/uploadFile'"
                                           :headers="{ token }"
                                           :data="{ fileType: 1}"
                                           accept=".mp4,.flv,.wmv,.mov,"
                                           :before-upload="beforeKtslUpload">
                                    <div style="display: flex">
                                        <div class="upload-btn-container">
                                            <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                            <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                        </div>
                                        <div class="upload-btn-tip">
                                            支持格式：mp4&nbsp;flv&nbsp;wmv&nbsp;mov &nbsp;&nbsp;大小限制：1G
                                        </div>
                                    </div>

                                </el-upload>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>上传教案
                            </div>
                            <div>
                                <el-upload class="upload-demo"
                                           v-model:file-list="jaFileList"
                                           :action="serviceUrl+'/businessservice/raceSign/uploadFile'"
                                           :headers="{ token }"
                                           :data="{ fileType: 2}"
                                           accept=".pdf,.jpg,.png"
                                           :before-upload="beforeJaUpload">
                                    <div style="display: flex">
                                        <div class="upload-btn-container">
                                            <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                            <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                        </div>
                                        <div class="upload-btn-tip">
                                            支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                        </div>
                                    </div>

                                </el-upload>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>上传课件
                            </div>
                            <div>
                                <el-upload class="upload-demo"
                                           v-model:file-list="kjFileList"
                                           :action="serviceUrl+'/businessservice/raceSign/uploadFile'"
                                           :headers="{ token }"
                                           :data="{ fileType: 3}"
                                           accept=".pdf,.doc,.docx,"
                                           :before-upload="beforeKjUpload">
                                    <div style="display: flex">
                                        <div class="upload-btn-container">
                                            <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                            <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                        </div>
                                        <div class="upload-btn-tip">
                                            支持格式：pdf&nbsp;word &nbsp;&nbsp; 大小限制：10M
                                        </div>
                                    </div>

                                </el-upload>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                上传说课
                            </div>
                            <div>
                                <el-upload class="upload-demo"
                                           v-model:file-list="skFileList"
                                           :action="serviceUrl+'/businessservice/raceSign/uploadFile'"
                                           :headers="{ token }"
                                           :data="{ fileType: 4}"
                                           accept=".mp3,.mp4,.mov"
                                           :before-upload="beforeSkUpload">
                                    <div style="display: flex">
                                        <div class="upload-btn-container">
                                            <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                            <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                        </div>
                                        <div class="upload-btn-tip">
                                            支持格式：mp3&nbsp;mp4&nbsp;.mov  &nbsp;&nbsp;大小限制：1G
                                        </div>
                                    </div>

                                </el-upload>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                补充说明
                            </div>
                            <div>
                                <el-input
                                  v-model="signForm.remarks"
                                  :rows="4"
                                  type="textarea"
                                  placeholder=""
                                />
                            </div>
                        </div>
                    </el-form>
                    <div class="apply-btn-container">
                        <div class="apply-btn" @click="submitRaceSign">
                            确定
                        </div>
                        <div class="apply-btn-back" @click="backTopicInfo">
                            返回
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--查看资料-->
        <div class="topic-detail" v-show="showMode==='info'">
            <div class="topic-sign-container">
                <div class="topic-sign-title">竞赛报名</div>
                <div class="topic-sign-name">
                    {{info.raceName}}
                </div>
                <div class="topic-sign-form">
                    <el-form ref="signForm" :model="signForm"
                             :rules="signRules"
                             label-position="top">
                        <div class="topic-sign-title">基本信息</div>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="教师姓名" prop="trueName">
                                    <el-input disabled v-model="signForm.trueName" placeholder="请输入教师姓名"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="所属学校" prop="trueName">
                                    <el-input disabled v-model="signForm.orgName" placeholder="请输入所属学校"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="任教学段" prop="periodKey">
                                    <el-select @change="changePeriod" disabled style="width: 100%;" v-model="signForm.periodKey"
                                               placeholder="请选择任教学段">
                                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="任教学科" prop="subjectKey">
                                    <el-select style="width: 100%;" disabled v-model="signForm.subjectKey"
                                               placeholder="请选择任教学科">
                                        <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="最高学历" prop="qualificationKey">
                                    <el-select style="width: 100%;" disabled v-model="signForm.qualificationKey"
                                               placeholder="请选择最高学历">
                                        <el-option v-for="item in qualificationList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="技术职称" prop="rankLevel">
                                    <el-select style="width: 100%;" disabled v-model="signForm.rankLevel"
                                               placeholder="请选择技术职称">
                                        <el-option v-for="item in rankList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="topic-sign-title">附件说明</div>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="课例名称" prop="lessonName" label-position="left">
                                    <el-input disabled v-model="signForm.lessonName" placeholder="请输入课例名称" />
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>课堂实录
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in signForm.ktslFileList" :key="item">
                                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_bf.png')"
                                                  @click="openVideo(item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>教案
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in signForm.jaFileList" :key="item">
                                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                <span style="color: red">*</span>课件
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in signForm.kjFileList" :key="item">
                                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                说课
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in signForm.skFileList" :key="item">
                                    <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_bf.png')"
                                                  @click="openVideo(item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="topic-file-container">
                            <div class="topic-file-item-title">
                                补充说明
                            </div>
                            <div>
                                <el-input
                                  disabled
                                  v-model="signForm.remarks"
                                  :rows="4"
                                  type="textarea"
                                  placeholder=""/>
                            </div>
                        </div>
                    </el-form>
                    <div class="apply-btn-container">
                        <div class="apply-btn-back" @click="backTopicInfo">
                            返回
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--成功-->
        <div class="topic-detail" v-show="showMode==='success'">
            <div class="success-container">
                <div class="success-content-container">
                    <div class="success-icon">
                        <svg t="1748229463840" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3548"><path d="M512 64C265 64 64 265 64 512s201 448 448 448 448-201 448-448S759 64 512 64z m-67 627.4l-0.2-0.2-0.2 0.2-179.2-179.2 45.2-45.2 134.2 134.1 268.6-268.5 45.2 45.2L445 691.4z" fill="#ff7f2e" p-id="3549"></path></svg>
                    </div>
                    <div class="success-title">资料已提交静待审核</div>
                    <div class="success-item-container">
                        <div class="success-item-title">竞赛名称：</div>
                        <div class="success-item-content">{{info.raceName}}</div>
                    </div>
                    <div class="success-item-container">
                        <div class="success-item-title">申报时间：</div>
                        <div class="success-item-content">{{ timestampToTime(applyTime)}}</div>
                    </div>
                    <div class="success-btn" @click="successConfirm">确认</div>
                </div>
            </div>
        </div>

        <el-dialog v-model="isAwareShow" width="760px">
            <img alt style="width: 720px;height: 500px" :src="awardUrl"/>
        </el-dialog>

        <!--音视频播放-->
        <el-dialog v-model="isShowVideo" width="76%" top="50px" @close="closeIframe">
            <iframe id="open-video" style="width: 100%;height:calc(100vh - 250px)" :src="videoSrc"
                    frameborder="0"></iframe>
        </el-dialog>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global";
import aMap from "@/components/aMap/index.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import { timestampToTime } from "@/utils/date";
import {downloadFile} from "@/api/adminservice/public";
import { raceInfo} from "@/api/admin/race";
import {queryDict} from "@/api/admin/public";
import {signRace} from "@/api/admin/raceSign"

export default {
    name: "raceInfo",
    components: {aMap, dataEmpty},
    props:{
        infoId:{
            type: String,
            default:null,
        },
    },
    watch:{
        infoId(newValue,oldValue){
            this.queryInfo()
        },
    },
    data() {
        return {
            serviceUrl,
            isShowMap: false,
            isAwareShow: false,
            token: this.$storage.get("token"),
            viewMode:'view',
            showMode:'view',
            detailMode:'view',
            signModel:'sign',
            fileModel:'info',
            successMode:"success",
            failMode:"fail",
            applyTime:Date.now(),
            timestampToTime,
            info:{},
            periodList: [],
            subjectList: [],
            qualificationList:[],
            rankList:[],
            //是否已报名
            isApply:0,
            // 表单校验
            delFileList:[],
            oldCenter: [],
            ktslFileList:[],//课堂实录
            jaFileList:[],//教案
            kjFileList:[],//课件
            skFileList:[],//说课
            signForm:{
                raceId:"",
                signType:1,
                trueName:"",
                orgId:"",
                orgName:"",
                periodKey:"",
                subjectKey:"",
                qualificationKey:"",
                rankLevel:"",
                lessonName:"",
                remarks:"",
                fileUrls:"",
            },
            signRules: {
                trueName: [{ required: true, message: "请输入教师姓名", trigger: "blur" },],
                orgName: [{ required: true, message: "请输入所属学校", trigger: "blur" },],
                periodKey: [{ required: true, message: "请选择任教学段", trigger: "change" },],
                subjectKey: [{ required: true, message: "请选择任教学科", trigger: "change" },],
                qualificationKey: [{ required: true, message: "请选择最高学历", trigger: "change" },],
                rankLevel: [{ required: true, message: "请选择技术职称", trigger: "change" },],
                lessonName: [{ required: true, message: "请输入课例名称", trigger: "blur" },],
            },
            awardUrl:'',
            isShowVideo:false,
            videoSrc:'',
        };
    },
    created() {
        this.userId = JSON.parse(this.$storage.get("userInfo")).userId
        this.signForm.trueName = JSON.parse(this.$storage.get("userInfo")).trueName
        this.signForm.orgId = JSON.parse(this.$storage.get("userInfo")).orgId
        this.signForm.orgName = JSON.parse(this.$storage.get("userInfo")).orgName
        this.getQueryDict();
    },
    mounted() {
        this.queryInfo()
    },
    computed: {},
    methods: {
        getQueryDict() {
            /*档案学段学科*/
            queryDict({ code: 'archive_xd_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            /*最高学历*/
            queryDict({ code: 'qualification' }).then(res => {
                this.qualificationList = res.data.data;
            })
            /*技术职称*/
            queryDict({ code: 'technical_title' }).then(res => {
                this.rankList = res.data.data;
            })
        },
        queryInfo(){
            raceInfo({ raceId: this.infoId }).then(res => {
                if (res.data.code===1){
                    this.info = res.data.data;
                    if (this.info.isApply===1){
                        this.isApply = 1;
                        this.signForm = this.info.raceSign;
                        queryDict({ code: 'archive_xd_xk' }).then(res => {
                            this.periodList = res.data.data;
                            this.subjectList = [];
                            this.periodList.forEach(j => {
                                if (this.signForm.periodKey === j.dictKey) {
                                    this.subjectList = j.childrenList;
                                }
                            })
                        })
                        //报名资料
                        this.ktslFileList = [];
                        this.signForm.ktslFileList.forEach(e => {
                            this.ktslFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.jaFileList = [];
                        this.signForm.jaFileList.forEach(e => {
                            this.jaFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.kjFileList = [];
                        this.signForm.kjFileList.forEach(e => {
                            this.kjFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.skFileList = [];
                        this.signForm.skFileList.forEach(e => {
                            this.skFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    code:1,
                                    data: e.fileUrl
                                }
                            })
                        })
                    }
                    // 地图
                    if (this.info.isEva === 1) {
                        this.isShowMap = true
                        this.oldCenter = [this.info.lng, this.info.lat]
                        setTimeout(() => {
                            this.$refs.zdyMap.center = this.oldCenter;
                            this.$refs.zdyMap.componentMarker.position = this.oldCenter;
                        }, 100)
                    }
                }
            })
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {
            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png');
            }
            return list;
        },
        handleApply() {
            this.reportForm.raceId = this.info.raceId;
            this.toReport = true;
            this.reportForm.achievement = ''
            this.reportForm.leaveWord = ''
            this.delFileList = [];
        },
        beforeUpload(rawFile) {
            return true
        },
        beforeKtslUpload(rawFile){
            if (!(rawFile.type === 'video/mp4' ||
              rawFile.type === 'video/x-flv' ||
              rawFile.type === 'video/quicktime' ||
              rawFile.type === 'video/x-ms-wmv')) {
                this.$message.error('文件必须是.mp4,.flv,.wmv,.mov格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 1024) {
                this.$message.error('文件超过规定大小1G')
                return false
            }
            return true
        },
        beforeJaUpload(rawFile){
            if (!(rawFile.type === 'application/pdf' ||
              rawFile.type === 'image/png' ||
              rawFile.type === 'image/jpg'||
              rawFile.type === 'image/jpeg')) {
                this.$message.error('暂不支持此类型文件')
                return false
            } else if (rawFile.size / 1024 / 1024 > 5) {
                this.$message.error('文件大小不得超过5M')
                return false
            }
            return true
        },
        beforeKjUpload(rawFile){
            if (!(rawFile.type === 'application/pdf' ||
              rawFile.type === 'application/msword' ||
              rawFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')){
                this.$message.error('文件必须是.pdf,.word格式')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('文件大小不能超过10M')
                return false
            }
            return true
        },
        beforeSkUpload(rawFile){
            if (!(rawFile.type === 'audio/mpeg' ||
              rawFile.type === 'video/quicktime' ||
              rawFile.type === 'video/mp4')){
                this.$message.error('文件必须是.mp3,.mp4或.mov格式')
                return false
            } else if (rawFile.size / 1024 / 1024 > 1024) {
                this.$message.error('文件超过规定大小1G')
                return false
            }

            return true
        },
        changeModel(){
            this.$emit('change-mode', this.pageMode);
        },
        getGeocoder(e) {
            if (this.info.isEva === 1) {
                this.info.lat = e.center[1];
                this.info.lng = e.center[0];
                this.info.address = e.formattedAddress;
            }

        },
        raceSignUp(){
            this.showMode = this.signModel;
        },
        viewSignUp(){
            this.showMode = this.fileModel;
        },
        backTopicInfo(){
            this.queryInfo();
            this.showMode = this.detailMode

        },
        successConfirm(){
            this.backTopicInfo()
        },
        changePeriod() {
            this.signForm.subjectKey = '';
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.signForm.periodKey === j.dictKey) {
                    this.subjectList = j.childrenList;
                }
            })
        },
        submitRaceSign(){
            this.signForm.raceId = this.info.raceId
            const fileList = [];
            if (this.ktslFileList.length === 0) {
                this.$message.error("请上传课堂实录文件")
                return
            }
            this.ktslFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })

            if (this.jaFileList.length === 0) {
                this.$message.error("请上传教案文件")
                return;
            }
            this.jaFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })

            if (this.kjFileList.length === 0) {
                this.$message.error("请上传课件文件")
                return;
            }
            this.kjFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.skFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })

            this.$refs["signForm"].validate(valid => {
                if (valid) {
                    const obj = JSON.parse(JSON.stringify(this.signForm));
                    obj.fileUrls = fileList.toString();
                    signRace(obj).then(res => {
                        if (res.data.code === 1) {
                            this.showMode = this.successMode;
                        }else {
                            this.$message.error("操作失败")
                        }
                    })
                }
            })
        },
        viewAware(info){
            this.awardUrl = info.awardUrl;
            this.isAwareShow = true;
        },
        openVideo(url){
            this.videoSrc = url;
            this.isShowVideo = true;
        },
        closeIframe() {
            const iframe = document.getElementById("open-video"); // 获取到要关闭的iframe元素
            iframe.setAttribute("src", '');
            if (typeof iframe !== "undefined" && iframe !== null) {
                var contentWindow = iframe.contentWindow; // 获取到iframe内部的window对象
                if (typeof contentWindow !== "undefined" && contentWindow != null) {
                    contentWindow.close(); // 调用close()方法关闭iframe
                } else {
                    console.log("无效的iframe或者未加载完成！");
                }
            } else {
                console.log("没有找到指定的iframe元素！");
            }
        },
    }
};
</script>
<style scoped>
.course-container{
    width: 100%;
    height: auto;
    //padding-left: 15px;
    padding-bottom: 10px;
    padding-right: 5px;
    box-sizing: border-box;
}
.topic-detail{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.sub-topic-top{
    width: calc(100% - 225px);
    height: 90px;
    background-color: #ff7f2e;
    display: flex;
    position: fixed;
    top: 80px;
    left: 210px;
    z-index: 999;
}
.topic-top-left{
    width: calc(100% - 380px);
    height: 100%;
}
.top-left1{
    height: 50px;
    width: 100%;
    color: #fff;
    line-height: 60px;
    text-indent: 30px;
    font-size: 20px;
    font-weight: bold;
    display: flex;
}
.status-info-cs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #00a173;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.status-info-cs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.status-info-fs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.status-info-zs{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.status-info-js{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #54bcbd;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 20px;
    text-indent: 0!important;
}
.top-left2{
    height: 50px;
    width: 100%;
    color: #fff;
    text-indent: 30px;
    font-size: 15px;
    font-weight: bold;
}
.topic-top-right{
    width: 380px;
    height: 100%;
    display: flex;
}
.right-ntn{
    width: 90px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.bm-btn{
    width: 80px;
    height: 30px;
    background-color: #fff;
    color: #ff7f2e;
    font-size: 14px;
    border-radius: 4px;
    line-height: 30px;
    text-align: center;
    margin: auto;
    font-weight: bold;
    cursor: pointer;
}
.right-ntn-auto{
    width: auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.right-zs-auto{
    width: auto;
    height: 100%;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
}
.zs-info{
    width: auto;
    font-size: 14px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    height: 40px;
    line-height: 44px;
}
.bm-btn-auto{
    width: auto;
    height: 30px;
    background-color: #fff;
    color: #ff7f2e;
    font-size: 14px;
    border-radius: 4px;
    line-height: 30px;
    text-align: center;
    margin: auto;
    font-weight: bold;
    cursor: pointer;
    padding: 0 10px 0 10px;
}

.topic-container{
    width: 100%;
    height: auto;
    background-color: #fff;
    padding-top: 100px;
}
.topic-name-container{
    width: 100%;
    height: 50px;
    line-height: 48px;
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    box-sizing: border-box;
    padding-left: 15px;

}
.topic-time-container{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding-left: 30px;
}
.topic-time-top{
    width: 100%;
    height: 30px;
    display: flex;
}
.topic-time-top1{
    width: 24px;
    height: 30px;
}
.topic-time-top2{
    width: calc(100% - 24px);
    height: 30px;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
}
.topic-jd{
    width: 100%;
    height: 24px;
    display: flex;
}
.topic-jd1{
    width: 24px;
    height: 30px;
}
.topic-point{
    width: 10px;
    height: 10px;
    background-color: #ff7f2e;
    border-radius: 5px;
    margin-top: 6px;
}
.topic-jd2{
    width: calc(100% - 24px);
    height: 30px;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
}
.topic-jd-time{
    height: 30px;
    border-left: 2px solid #ff7f2e;
    margin-left: 4px;
    text-indent: 20px;
    font-size: 14px;
    color: #767676;
    font-weight: bold;
}
.time-active{
    color: #ff7f2e!important;
}
.topic-jd-time-end{
    height: 30px;
    margin-left: 4px;
    text-indent: 20px;
    font-size: 14px;
    color: #767676;
    font-weight: bold;
}
.topic-title-container{
    width: 100%;
    height: 40px;
    display: flex;
}
.topic-title-container1{
    width: 50px;
    height: 40px;
    padding-left: 16px;
    box-sizing: border-box;
    padding-top: 8px;
}
.topic-title-container2{
    width: calc(100% - 50px);
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #ff7f2e;
}
.topic-base-info-container{
    width: 100%;
    height: auto;
    padding-left: 50px;
    box-sizing: border-box;
}
.base-one-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.base-one-info{
    width: 40%;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.base-one-info-80{
    width: 80%;
    height: auto;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.topic-content-container{
    width: 96%;
    height: auto;
    padding-left: 50px;
    box-sizing: border-box;
    text-indent: 30px;
    font-size: 14px;
    color: #767676;
    line-height: 24px;
    word-break: break-all;
    font-weight: bold;
}
.topic-content-container-img{
    width: 100%;
    height: auto;
    padding-left: 50px;
    box-sizing: border-box;
    font-size: 14px;
    color: #767676;
    line-height: 24px;
}
.topic-sign-title-second{
    display: flex;
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    padding-left: 50px;
    box-sizing: border-box;
}
.topic-file-container-second{
    width: calc(100% - 90px);
    height: auto;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 10px 10px 10px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
    margin-top: 5px;
    margin-left: 50px;
}
.file-item-second{
    display: flex;
    height: 30px;
    width: 100%;
    padding-right: 30px;
    box-sizing: border-box;
    cursor: pointer;
}
.file-item-second:hover{
    color: #ff7f2e!important;
    font-weight: bold;
}
.file-list{
    width: 100%;
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 50px;
    padding-right: 50px;
    box-sizing: border-box;
    cursor: pointer;
}
.file-item:hover{
    color: #ff7f2e!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
}
.file-view{
    width: 30px;
    height: 100%;
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.back-btn-container{
    width: 100%;
    height: 60px;
    background-color: #fff;
    padding-top: 15px;
    box-sizing: border-box;
}
.back-btn{
    width: 80px;
    height: 30px;
    line-height: 30px;
    border-radius: 6px;
    background-color: #ff7f2e;
    font-size: 14px;
    text-align: center;
    color: #fff;
    margin: auto;
    cursor: pointer;
    font-weight: bold;
}
.topic-sign-container{
    width: 100%;
    height: auto;
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 10px;
    box-sizing: border-box;
}
.topic-sign-title{
    display: flex;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #ff7f2e;
    margin-bottom: 5px;
    margin-top: 5px;
}
.topic-sign-name{
    width: 100%;
    height: 30px;
    //line-height: 30px;
    font-size: 15px;
    color: #767676;
}
.topic-sign-form{
    width: 100%;
    height: auto;
}
.item-title-tio{
    font-size: 14px;
    color: #767676;
    font-weight: normal!important;
    margin-left: 60px;
}
/deep/ .el-form-item{
    //margin-bottom: 10px!important;
}
/deep/ .el-form-item__label{
    color:#333333!important;
    font-weight:bold;
    font-size:13px
}
.topic-file-container{
    width: 98%;
    height: auto;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 10px 10px 10px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
    margin-top: 5px;
}
.topic-file-item-title{
    height: 30px;
    color:#333333;
    font-weight:bold;
    font-size:14px
}
.upload-btn-container{
    width: 160px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #ff7f2e;
    color: #fff;
    border-radius: 5px;
    display: flex;
}
.upload-btn-tip{
    text-indent: 40px;
    line-height: 40px;
    font-size: 13px;
    font-weight: bold;
    color: #767676;
}
.apply-btn-container-back{
    width: 100%;
    height: 50px;
}
.apply-btn-back{
    width: 80px;
    height: 34px;
    line-height: 34px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #ff7f2e;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}
.apply-btn-container{
    width: 200px;
    height: 40px;
    padding-top: 30px;
    display: flex;
    margin: auto;
}
.apply-btn{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #ff7f2e;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}
.apply-btn-back{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #FFFFFF;
    color: #909399;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
    border: 1px solid #909399;
}
.bg-dsh{
    background-color: #93d2f3;
    color: #fff!important;
}
.bg-ytg{
    background-color: #81b336;
    color: #fff!important;
}
.bg-wtg{
    background-color: #bd3124;
    color: #fff!important;
}
.bg-dj{
    background-color: #ffbf6b;
    color: #fff!important;
}
.bg-xc{
    background-color: #93d2f3;
    color: #fff!important;

}
.file-list{
    width: 100%;
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 20px;
    padding-right: 50px;
    box-sizing: border-box;
    cursor: pointer;
}
.file-item:hover{
    color: #ff7f2e!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
}
.file-view{
    width: 30px;
    height: 100%;
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
/*申报成功*/
.success-container{
    width: 100%;
    height: calc(100vh - 100px);
    overflow-y: hidden;
    background-color: #fff;
}
.success-content-container{
    width: 40%;
    height: 100%;
    margin: auto;
}
.success-title{
    width: 100%;
    height: 80px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    color: #000;
}
.success-icon{
    width: 64px;
    height: 124px;
    padding-top: 60px;
    box-sizing: border-box;
    margin: auto;
}
.success-item-container{
    width: 100%;
    height: auto;
    display: flex;
    padding-bottom: 5px;
}
.success-item-title{
    width: 140px;
    font-size: 15px;
    color: #767676;
    text-align: right;
}
.success-item-content{
    width: calc(100% - 140px);
    height: auto;
    line-height: 20px;
    font-size: 15px;
    color: #333;
    text-align: left;
    padding-left: 15px;
    box-sizing: border-box;
}
.success-btn{
    width: 100px;
    height: 36px;
    line-height: 36px;
    margin: auto;
    margin-top: 50px;
    text-align: center;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #ff7f2e;
    cursor: pointer;
}
.part-container{
    width: 80%;
    padding-top: 10px;
}


</style>

